@use '@shared/styles/media' as media;

.page-error-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.error {
  font-size: 10rem;
  color: var(--tg-theme-button-color);
  text-shadow: var(--default-text-shadow);
}

@media (max-width: media.$maxWidthTablet) {
  .error {
    font-size: 12rem;
  }
}

@media (max-width: media.$maxWidthPhoneRotated) {
  .page-error-block {
    p {
      text-align: center;
    }
  }
  .error {
    font-size: 7rem;
  }
}
